/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { appendGTMHeader, removeGTMScript } from "../../../utils/GoogleGTM";
import { IFormSignup, SignupFormSection } from "../Form";
import ChoosePasscode from "./ThirdForm/ChoosePasscode";
import ConfirmPasscode from "./ThirdForm/ConfirmPasscode";
import LearnisticChoosePasscode from "./ThirdForm/LearnisticChoosePasscode";
import LearnisticConfirmPasscode from "./ThirdForm/LearnisticConfirmPasscode";
import LearnisticEnterPasscode from "./ThirdForm/LearnisticEnterPasscode";
import LearnisticTemporaryPasscode from "./ThirdForm/LearnisticTemporaryPasscode";
import TemporaryPasscode from "./ThirdForm/TemporaryPasscode";

export const PasscodeContainer = styled.div`
  width: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 48px;

  > div + div {
    margin-top: 24px;
  }
`;

export const PasscodeWrapper = styled.div`
  width: 360px;
`;

export const PasscodeButtonsWrapper = styled.div`
  width: 100%;
  margin-top: 48px !important;
  display: flex;
  align-items: center;
  justify-content: center;

  > button {
    width: 100%;
  }

  > button + button {
    margin-left: 16px;
  }
`;
interface ThirdFormProps {
  selectedForm: SignupFormSection;
  setSelectedForm: React.Dispatch<React.SetStateAction<SignupFormSection>>;
  form: IFormSignup;
  handleChangeForm: (key: string, value: string[]) => void;
}

export interface PasscodeProps {
  setSelectedForm: React.Dispatch<React.SetStateAction<SignupFormSection>>;
  form: IFormSignup;
  handleChangeForm: (key: string, value: string[]) => void;
}

export default function ThirdForm({
  selectedForm,
  setSelectedForm,
  form,
  handleChangeForm,
}: ThirdFormProps) {
  useEffect(() => {
    const sc = appendGTMHeader();

    return () => {
      removeGTMScript(sc);
    };
  }, []);

  function getPasscodePage() {
    if (selectedForm === SignupFormSection.TemporyPasscode) {
      return (
        <TemporaryPasscode
          setSelectedForm={setSelectedForm}
          form={form}
          handleChangeForm={handleChangeForm}
        />
      );
    }
    if (selectedForm === SignupFormSection.ChoosePasscode) {
      return (
        <ChoosePasscode
          setSelectedForm={setSelectedForm}
          form={form}
          handleChangeForm={handleChangeForm}
        />
      );
    }
    if (selectedForm === SignupFormSection.ConfirmPasscode) {
      return (
        <ConfirmPasscode
          setSelectedForm={setSelectedForm}
          form={form}
          handleChangeForm={handleChangeForm}
        />
      );
    }
    if (selectedForm === SignupFormSection.EnterPasscodeLearnistic) {
      return (
        <LearnisticEnterPasscode
          setSelectedForm={setSelectedForm}
          form={form}
          handleChangeForm={handleChangeForm}
        />
      );
    }
    if (selectedForm === SignupFormSection.TemporyPasscodeLearnistic) {
      return (
        <LearnisticTemporaryPasscode
          setSelectedForm={setSelectedForm}
          form={form}
          handleChangeForm={handleChangeForm}
        />
      );
    }
    if (selectedForm === SignupFormSection.ChoosePasscodeLearnistic) {
      return (
        <LearnisticChoosePasscode
          setSelectedForm={setSelectedForm}
          form={form}
          handleChangeForm={handleChangeForm}
        />
      );
    }
    if (selectedForm === SignupFormSection.ConfirmPasscodeLearnistic) {
      return (
        <LearnisticConfirmPasscode
          setSelectedForm={setSelectedForm}
          form={form}
          handleChangeForm={handleChangeForm}
        />
      );
    }
  }

  return <>{getPasscodePage()}</>;
}
